<template>
    <section class="question-single-content-wrapper pt-80px pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-2">
                    <questions-sidebar />
                </div>

                <div class="col-md-7">
                    <div class="question-single-content d-flex pb-30px">
                        <question-vote />

                        <div class="question-single-content-right">
                            <p>
                                I want to create a SPA web application (ASP.NET Core Web API + Angular). I have a controller that returns a list of objects, and I have an angular component that is a list of objects, but this list doesn't need all the information that comes from the API. What is the best way to do: create another object in the controller and return certain information or just edit the data in the component?
                            </p>
                            <ul class="question-tags mt-3 d-flex flex-wrap align-center">
                                <li><a href="#">angular</a></li>
                                <li><a href="#">asp.net-core-webapi</a></li>
                            </ul>

                            <div class="question-share-and-signature d-flex justify-content-between mt-4 pb-30px">
                                <ul class="question-share-btns d-flex">
                                    <li><a href="#">Share</a></li>
                                    <li><a href="#">Edit</a></li>
                                    <li><a href="#">Follow</a></li>
                                    <li><a href="#">Flag</a></li>
                                </ul>

                                <div class="question-signature">
                                    <span class="asked-time">asked 2 days ago</span>
                                    <a href="#" class="question-signature-inner d-flex">
                                        <img :src="require('@/assets/images/team-1.png')" alt="User">
                                        <div class="question-user-details">
                                            <span class="user-name">Developer Tanbir</span>
                                            <div class="flair d-flex align-center">
                                                <span class="reputation-score">331</span>
                                                <span class="user-badge d-flex align-center">
                                                    <span class="type-badge badge-bronze"></span>
                                                    13
                                                </span>
                                                <span class="user-badge d-flex align-center">
                                                    <span class="type-badge badge-silver"></span>
                                                    2
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            
                            <!-- Question Comments -->
                            <question-comment :comments="comments" />

                        </div>
                    </div>

                    <div class="question-single-answer-wrapper">
                        <div class="question-single-answer-header align-center d-flex justify-content-between mb-4">
                            <h1>Answer <span>1</span></h1>
                            <div class="question-signle-answer-filter">
                                <el-select v-model="answerFilter" filterable clearable placeholder="Select" size="large">
                                    <el-option
                                        v-for="item in answerFilterOption"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        />
                                </el-select>
                            </div>
                        </div>

                        <div class="question-single-answer-box d-flex mb-30px pb-30px">
                            <question-answer-vote />

                            <div class="question-single-answer-content-right">
                                <p>Good approach would be to return only the required properties in typed object from the Angular Service, so the component knows exactly the type and has access only to properties it needs:</p>

<pre class="question-code-block" v-highlightjs="sourcecode">
<code class="javascript">
    interface DataDTO {
        importantProp1: string;
        importantProp2: string;
        otherProp3: string;
    }

    export interface Data {
        importantProp1: string;
        importantProp2: string;
    }

    export class ApiService {

        getData(): Observable&lt;Data[]&gt; {

            return this.http.get&lt;DataDTO[]&gt;('url').pipe(
                map(response => response.map(item => ({
                    importantProp1: item.importantProp1;
                    importantProp2: item.importantProp2;
                }))),
            );
        }

    }
</code>
</pre>

                                <div class="question-share-and-signature d-flex justify-content-between mt-4 pb-30px">
                                    <ul class="question-share-btns d-flex">
                                        <li><a href="#">Share</a></li>
                                        <li><a href="#">Edit</a></li>
                                        <li><a href="#">Follow</a></li>
                                        <li><a href="#">Flag</a></li>
                                    </ul>

                                    <div class="question-signature">
                                        <span class="asked-time">answered Aug 5 at 11:11</span>
                                        <a href="#" class="question-signature-inner d-flex">
                                            <img :src="require('@/assets/images/team-1.png')" alt="User">
                                            <div class="question-user-details">
                                                <span class="user-name">Tanbir</span>
                                                <div class="flair d-flex align-center">
                                                    <span class="reputation-score">1,331</span>
                                                    <span class="user-badge d-flex align-center">
                                                        <span class="type-badge badge-gold"></span>
                                                        2
                                                    </span>
                                                    <span class="user-badge d-flex align-center">
                                                        <span class="type-badge badge-silver"></span>
                                                        35
                                                    </span>
                                                    <span class="user-badge d-flex align-center">
                                                        <span class="type-badge badge-bronze"></span>
                                                        13
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            
                                <!-- Question Comments -->
                                <question-comment :comments="[]" />

                            </div>
                        </div>

                        <div class="question-single-answer">
                            <h1>Your answer</h1>
                            <tinymce id="d2" v-model="bodyContent" ></tinymce>
                            <el-button class="btn theme-btn mt-3">Post your answer</el-button>
                        </div>

                    </div>
                </div>


                <div class="col-md-3">
                    <questions-sidebar-2 />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import tinymce from 'vue-tinymce-editor'
import QuestionsSidebar from '../sidebars/QuestionsSidebar.vue'
import QuestionVote from '../pieces/question/QuestionVote.vue'
import QuestionComment from '../pieces/question/QuestionComment.vue'
import QuestionAnswerVote from '../pieces/question/QuestionAnswerVote.vue'
import QuestionsSidebar2 from '../sidebars/QuestionsSidebar2.vue';


export default {
    name: 'QuestionSingleDetails',
    components: {
        QuestionsSidebar,
        QuestionVote,
        QuestionComment,
        QuestionAnswerVote,
        tinymce,
        QuestionsSidebar2,
    },
    data() {
        return {
            commentContent: '',
            answerFilter: 'highest-score',
            answerFilterOption: [
                {
                    label: 'Highest score (default)',
                    value: 'highest-score'
                },
                {
                    label: 'Trending (recent votes count more)',
                    value: 'trending'
                },
                {
                    label: 'Date modified (newest first)',
                    value: 'date-modified'
                },
                {
                    label: 'Date created (oldest first)',
                    value: 'date-created'
                }
            ],
            comments: [
                {
                    content: "Please put a sample piece of code that you're trying to do rather than putting a long description. thanks!",
                    author: 'Tanbir Ahmod',
                    date: '2 days ago'
                }
            ],
            bodyContent: '',
        }
    },
}
</script>